<template>
  <div class="home">
    <b-container>
      <ExportLink class="marginalsm"></ExportLink>

    </b-container>
  </div>
</template>

<script>
import ExportLink from '@/components/ExportLink.vue';


export default {
  name: 'export',
  components: {
    ExportLink
  }
}
</script>
